import React from 'react'
import styles from './Hotspot.module.css'

function Hotspot(props) {
  const { el, style, visible, onClick } = props
  
  if(!visible) {
    return null
  }

  if(!el) {
    return (
      <div
        className={styles.base}
        style={style}
        onClick={onClick}
      >
        <div
          className={styles.bubble}
        />
      </div>
    )
  }

  const rect = el().getBoundingClientRect()
  const offsetX = rect.left + rect.width / 2 - 11
  const offsetY = rect.top + window.pageYOffset + rect.height / 2 - 11

  const customStyle = {
    left: `${offsetX}px`,
    top: `${offsetY}px`,
    // ...hotspotStyle,
  }

  return (
    <div
      className={styles.base}
      style={customStyle}
      onClick={onClick}
    >
      <div
        className={styles.bubble}
      />
    </div>
  )
}

Hotspot.defaultProps = {
  visible: true,
}

export default Hotspot